<script setup lang="ts">
import IconCookies from 'assets/icons/cookie.svg';

const padding = useBigLayoutPadding();
const { t } = useI18n();

const allowStatus = useLocalStorage<'pending' | 'allow' | 'reject'>('allow-cookies', 'pending');
</script>

<template>
  <div
    v-if="allowStatus==='pending'"
    class="fixed flex flex-col gap-4 max-w-[506px] bottom-8 p-4 bg-gray-100 shadow-highlight rounded-big"
    :style="{
      right: `${padding}px`,
    }"
  >
    <div class="flex gap-4">
      <IconCookies class="!w-[43px] !h-[43px] shrink-0" />
      <div class="text-big text-gray-900">
        {{ t('Cookies') }}
      </div>
    </div>
    <div class="flex justify-end gap-4">
      <ButtonLevel
        :title="t('Reject_all')"
        type="3"
        @click="allowStatus='reject'"
      />
      <ButtonLevel
        :title="t('Accept_all')"
        type="2"
        @click="allowStatus='allow'"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
